import { createFileRoute } from '@tanstack/react-router'
import { CustomJobCreatePage } from '@/features/custom-jobs/create-form'

export const Route = createFileRoute('/_authenticated/company-jobs/custom-job/new')({
  component: CustomJobCreatePage,
})
